<template>
<div v-if="facility !== null" class="facility-stats-pane">
    <card size="small">
        <template slot="body">
            <div class="cu-p pos-r" @click="visible = !visible">
                <span class="toggle vertically-center">
                    <span v-show="!visible"><i class="material-icons">keyboard_arrow_up</i></span>
                    <span v-show="visible"><i class="material-icons">keyboard_arrow_down</i></span>
                </span>

                <strong class="d-b ta-c">Your Facility</strong>
            </div>

            <div class="flex fd-c mt-1">
                <div class="flex fd-c" v-show="visible">
                    <div class="facility-number ws-nw">
                        ID: <strong>{{ facility.facility_number }}</strong>
                    </div>

                    <div class="address mt-1 ws-nw">
                        {{ facility.address }}<br />
                        {{ facility.city }}, {{ facility.state }} {{ facility.zip_code }}
                    </div>

                    <div class="flex ai-fe jc-sb mt-1">
                        <span class="gray-message">Charge Applied</span>
                        <div class="ml-5">
                            <span>{{ (facility.stats.charge_applied) ? facility.stats.charge_applied : 0 }}</span>
                            <span>({{ facility.stats.charge_applied_percentage }}%)</span>
                        </div>
                    </div>

                    <div class="flex ai-fe jc-sb mt-1">
                        <span class="gray-message">Opted Out</span>
                        <div class="ml-5">
                            <span>{{ (facility.stats.opted_out) ? facility.stats.opted_out : 0 }}</span>
                            <span>({{ facility.stats.opted_out_percentage }}%)</span>
                        </div>
                    </div>

                    <div class="flex ai-fe jc-sb mt-1">
                        <span class="gray-message">Provided Proof</span>
                        <div class="ml-5">
                            <span>{{ (facility.stats.provided_proof) ? facility.stats.provided_proof : 0 }}</span>
                            <span>({{ facility.stats.provided_proof_percentage }}%)</span>
                        </div>
                    </div>

                    <div class="flex ai-fe jc-sb mt-1">
                        <span class="gray-message">Selected Coverage</span>
                        <div class="ml-5">
                            <span>{{ (facility.stats.selected_coverage) ? facility.stats.selected_coverage : 0 }}</span>
                            <span>({{ facility.stats.selected_coverage_percentage }}%)</span>
                        </div>
                    </div>
                </div>

                <hr class="small" />

                <div class="flex ai-fe jc-sb">
                    <span class="gray-message">Total Tenants</span>
                    <strong class="ml-5">{{ facility.stats.total }}</strong>
                </div>
            </div>
        </template>
    </card>
</div>
</template>

<script>
import store from "@/store"

export default {
    name: "facility-stats-pane",

    props: {
        alwaysOpen: {
            default: false
        },

        hidden: {
            default: true
        }
    },

    data () {
        return {
            visible: !this.hidden
        }
    },

    computed: {
        facility () {
            return store.state.userFacility.facility
        }
    }
}
</script>

<style>
.facility-stats-pane {
    font-size: 0.9em;
    line-height: 1.3;
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 3;
}

.facility-stats-pane .toggle {
    color: inherit;
    font-size: 0.9em;
    position: absolute;
    right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/FacilityStatsPane.vue